export const Matomo = {
  sync(state) {
    (window._paq = window._paq || []).push([state.measurement ? 'setConsentGiven' : 'forgetConsentGiven']);
  },
};
